import { Icon } from "leaflet"
import React, { Component } from "react";
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import {
    Container,Row,  Col,  Button,  Card,  CardBody,  CardTitle,  Modal,  ModalHeader,
      Input, CardFooter,Spinner, CardHeader,InputGroup} from "reactstrap"

import ReactSelect from 'react-select'
import {components} from 'react-select'
import makeAnimated from 'react-select/animated';
import axios from 'axios'
import { format } from 'date-fns';
import  { Redirect } from 'react-router-dom'
import {PDFDownloadLink } from '@react-pdf/renderer';
import ModalMessage from "../pages/messages/ModalMessage"
import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import $ from "jquery";
import url from "../../common/api"
import urlFile from "../../common/ApiFile"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"

import {getUniteAdministrativeList} from "../../services/uniteAdministrativeService.js"

import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getTypeExpertList} from "../../services/typeExpertService.js"
import {getPaysList} from "../../services/paysService.js"
import {getStructureList} from "../../services/structureService.js"
import {getCategorieList} from "../../services/categorieService.js"
import {updateExpert,removeSousTypeInExpert,removeElements} from "../../services/expertService.js"
import Confirmer from "pages/Dashboard/Confirmer";
// import DocumentPdf from "./Document"
import CreatableSelect from 'react-select/creatable';
import {getQueries} from "../../queries/getQueries.js";
import {deleteQueries} from "../../queries/deleteQueries.js";
import { registerUserFailed } from './../../store/auth/register/actions';

const Menu = props => {
  const optionSelectedLength = props.getValue().length || 0;
  return (
    <components.Menu {...props}>
      {optionSelectedLength < 5 ? (
        props.children
      ) : (
        <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mot-clés</div>
      )}
    </components.Menu>
  );
};

class DetailExpert extends Component {
  constructor(props) {
    super(props)
    this.patch.bind(this)
    this.remove.bind(this)
    this.handleDeleteLocalisation.bind(this)
    this.handleDeleteLangue.bind(this)
  
    this.handleDeleteSysteme.bind(this)
    this.handleDeleteThematique.bind(this)
    this.handleDeleteSousTypeExpert.bind(this)
 
    //check
    this.handleCheckLocalisation.bind(this)
    this.handleCheckLangue.bind(this)
    this.handleCheckThematique.bind(this)
    this.handleCheckSysteme.bind(this)
    this.handleCheckSousTypeExpert.bind(this)
    this.handleChangeProfile.bind(this);
    this.handleChangeType.bind(this)

   // this.handleUpdateThematique(this)
    this.state = {ok:"", expert:{},structure:[],sous_type_expert:[],structures:[],categories:[],systeme:[],langue:[],thematique:[],auteur:[],auteurs:[],localite:[],
   langues:[],unites:[],auteurs:[], irrigues:[],sous_type_ressources:[],type_experts:[],sous_type_experts:[],profiles:[],motcles:[],thematiques:[],localisations:[],
    idExpert:sessionStorage.getItem("idExpert"),
    checkAcces:{},checkThematique:[],checkSousTypeExpert:[],checkSpecialite:[],checkStructure:[],checkAuteur:[],checkLangue:[],checkLocalisation:[],checkSysteme:[],
    thematique_data:[],systeme_data:[],strucure_data:[],specialite_data:[],langue_data:[],chargement:false,hide:"block",
    profiles_attributes:[],public_id:0,profile:[], sous_type_expert_attributes:[],
    show:false,
    success:true,
    validate_update:false,
    chargement_data:false, 
    accept_update:true,
    public_init_id:0,
    message:"Fiche de l'acteur modifié avec succès !",
    titre:"Message modification fiche acteur", 
    boutton:"OK",
    type_personne:"Personne Morale",
    acces:{},
    remove_data:{} ,
    type:props.type , 
    index:props.index , 
    profile_user:JSON.parse(sessionStorage.getItem("profileAuthAshia")),
    block_acces:false,
    is_compte:false,
    status_compte:[{value:"ACTIVE",label:"Compte activé"},{value:"DESACTIVE",label:"Compte désactivé"}],
    open_delete:false
    }

  }

  handleDroit=()=>{



    //droit

    $(".owener").hide()
    $("#profiles").hide()
    $("#profile").hide()
    //
    $("#date").hide()
    $("#editerlien").hide()
    $("#editerdate").hide()
    $("#ddpe").hide()
    $("#dfpe").hide()

    //Tableaux
    $("#soustypeacteur").hide()
    $("#typesystemeirrigation").hide()
    $("#soustypesystemeirrigation").hide()
    $("#typederessource").hide()
   
    $("#langue").hide()
    $("#sous_type").hide()
    $("#motcle").hide()
    $("#localisation").hide()
    $("#thematique").hide()
    $("#auteur").hide()
    $("#uniteadministrative").hide()

    $("#show-tsi").hide()
    $("#show-stsi").hide()
    $("#show-langue").hide()
    $("#show-motcle").hide()
    $("#show-localisation").hide()
    $("#show-thematique").hide()
    $("#show-auteur").hide()
    $("#show-type-expert").hide()
    $("#show-acces").hide()
    $("#show-ua").hide()
    
    //Bouttons
    $("#bouttonmodifier").hide()

    //Block des input
    $("#show-image").hide()
    $("#show-video").hide()
    $("#show-pj").hide()

    $("#show-format").hide()
    $("#valideState").hide()
    $("#show-ok-format").hide()

    $("#show-categorie").hide()
    $("#valideStateCategorie").hide()
    $("#show-ok-categorie").hide()

    $("#show-structure").hide()
    $("#valideStateStructure").hide()
    $("#show-ok-structure").hide()

    $("#show-statut").hide()
    $("#valideStateStatut").hide()
    $("#show-ok-statut").hide()
 
    $("#show-type-ressource").hide()
    $("#valideRessource").hide()
    $("#show-ok-tr").hide()

    $("#show-sous-type-ressource").hide()
    $("#valideRessource").hide()
    $("#show-ok-str").hide()


    
  }

  handleChargeAll=()=>{
    this.handleDroit()
    const data=this.state.expert

 
    $("#nom").val(data.nom)
    $("#prenom").val(data.prenom)
    $("#telephone").val(data.telephone)
    $("#type-expert").val(data.type_expert?.libelle)
    $("#email").val(data.email)
    $("#adresse").val(data.adresse)

  

    try{
     $("#categorie").val(data.categorie.libelle)
    }catch(e){

    }
    try{
        $("#structure").val(data.structure.libelle)
       }catch(e){

       }
    try{
        $("#format").val(data.format.libelle)
       }catch(e){


  }
  }


  componentDidMount(){

    sessionStorage.setItem("sis-session",900000)

    //fetch expert
    this.getData()

      //chargement des données
    this.handleCharge()
  }


  getData=()=>{
   
    var id=sessionStorage.getItem("idExpert")
    $(".owener").hide()
    $(".owener2").hide()
    $("#profile").hide()
    if(this.state.index===true){
          $("#droit_d").hide()
          $("#droit").hide()
    }
    this.setState({hide:"none",chargement:false,chargement_data:false,validate_update:false})
    var taille=0
   


    axios.get(url+"utilisateurs/"+id)
    //.then((response) => response.json())
    .then(res => {
        const data=res.data

        this.setState({chargement:true})
        this.handleDroit()
        this.setState({expert:data})
        console.log("ress",data)
      
       
        this.setState({langue:data.langues,sous_type_expert:data.sous_type_experts,systeme:data.type_systeme_irrigues})
        this.setState({acces:data.profile})
      
        this.setState({thematique:data.thematiques})

        this.setState({localite:data.pays})
         
        data.type_expert?.sous_type_experts.map((val)=>{
          this.setState({sous_type_experts:[...this.state.sous_type_experts,{value:val.id,label:val.libelle}]})
        })

       

        $("#nom").val(data.nom)
        $("#prenom").val(data.prenom)
        $("#telephone").val(data.telephone)
        $("#type-expert").val(data.type_expert?.libelle)
        $("#structure").val(data.structure?.libelle)
        $("#email").val(data.email)
        $("#adresse").val(data.adresse)


        if(data.prenom){
          this.setState({type_personne:"Personne Physique"})
        }

       
        if(this.state.index===true){
          $("#droit").hide()
          $("#droit_d").hide()
        }

      

        try{
         $("#categorie").val(data.categorie.libelle)
        }catch(e){

        }
        try{
            $("#structure").val(data.structure.libelle)
           }catch(e){
   
           }
        try{
            $("#format").val(data.format.libelle)
           }catch(e){
   
        }   
       
      })

    

  }

  handleRetour=()=>{
    if(this.state.index===true){
        $('#block_detail_ressource').hide()
        $('#acceuil-link').show()
        $('#block_page_acceuil').show()
        return 
    }else{
    this.setState({ok: <Redirect to='/liste-expert'  />});
    return
    }
  }

  
 
  handleChargeLangue=()=>{
      
    getLanguageList().then(e=>{
      let langue1 = this.state.langue.map(val => { return val.id});
       
      let langue2 = e?.filter(itemX => !langue1.includes(itemX.value));
     
      this.setState({langues:langue2})
      $("#langue").show()
      $("#no-show-langue").hide()
      $("#show-langue").show()
    })
   
  }
  handleChargeCategorie=()=>{
    getCategorieList().then(e=>this.setState({categories:e}))
   
  }
  handleChargeLocalisation=()=>{
      
    getPaysList().then(e=>
      {
        let pay1 = this.state.localite.map(val => { return val.id});
       
        let pay2 = e?.filter(itemX => !pay1.includes(itemX.value));
       
        this.setState({localisations:pay2})
         $("#localisation").show()
         $("#no-show-localisation").hide()
         $("#show-localisation").show()
      })
 
   
  }
  handleChargeTypeExpert=()=>{
      
    getTypeExpertList().then(e=>{
      this.setState({type_experts:e})
    
    })
 
   
  }
  handleChargeSysteme=()=>{

    getTypeSystemeIrrigueList().then(e=>{
      let auteur1 = this.state.systeme.map(val => { return val.id});
       
      let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));
     
      this.setState({irrigues:auteur2})
       $("#typesystemeirrigation").show()
       $("#no-show-tsi").hide()
       $("#show-tsi").show()
    })
   
  }

  
  handleChargeThematique=()=>{
    getThematiqueList().then(e=>{
      let auteur1 = this.state.thematique.map(val => { return val.id});
       
      let auteur2 = e?.filter(itemX => !auteur1.includes(itemX.value));
     
      this.setState({thematiques:auteur2})
      $("#thematique").show()
      $("#no-show-thematique").hide()
      $("#show-thematique").show()
    })
      
  }

  handleChargeStructure=()=>{
    getStructureList().then(e=>this.setState({structures:e}))
      
  }

 

  handleCharge=()=>{

    

    getQueries("profiles").then(e=>{
      const data=e
      try{
        this.setState({public_init_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id,
       
      })
        
       }catch(error){
  
       }

       data.filter(x => (x.libelle).toLowerCase() != ("Public").toLowerCase()).map((element,idx) =>{
        this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
      })

    })

  
  }

  
  

    handleProfile=()=>{
      $("#profile").show()
      $("#no-show-acces").hide()
      $("#show-acces").show()
    }



    patch=(data)=>{
      var id=sessionStorage.getItem("idExpert")
      const requestOptions = {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
          body: JSON.stringify(data)
      };
      fetch(url+"utilisateurs/"+id, requestOptions)
      .then((response) => response.json())
      .then(response =>{console.log("ok,",response)
      this.setState({message:"Elément modifier avec succès!!"})
      this.setState({show:true,success:true});
      setTimeout(()=>
        window.location.reload(false)
      , 1000)
      
      //this.handleChargeAll()
      $(".owener").hide()
      } ,
      (error) => {
        $(".owener").hide()
      })
    }

    remove=(data,Url)=>{
      
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
          body: JSON.stringify(data)
      };
    
        fetch(url+Url,requestOptions)
        .then((response) => response.json())
        .then(response =>{console.log("ok,",response)
        this.setState({message:"Elément supprimer"})
        this.setState({show:true,success:true});
        
    
        } ,
        (error) => {
          console.log("erreur,",error)
        })
    }

   
    handleMDP=()=>{
      document.getElementById("mdp").readOnly = false;
    }
  


   
    handleStructure=()=>{;
      $("#structure").hide()
      $("#show-structure").show()
      $("#valideStateStructure").show()

      $("#no-show-ok-structure").hide()
      $("#show-ok-structure").show()
    }


  
    handleUpdateProfile=()=>{
      if($("#show-acces option:selected").val()!=0){
      this.patch({"profile_id":this.state.profile_id})
      $("#profile").val($("#show-acces option:selected").text())
     
      }
     
      $("#profile").hide()
      $("#show-acces").hide()
      $("#valideRessource").hide()

      $("#no-show-ok-str").show()
      $("#show-ok-str").hide()
    }




    // remove
 
    handleDeleteLangue=(id)=>{
      this.setState({validate_update:true})
        var data={"utilisateur_id":this.state.idExpert,"langue_id":id}
        // this.remove(data,"utilisateur_langue/delete")
        try{
          this.state.remove_data["utilisateur_langue/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["utilisateur_langue/delete"]=[]
          this.state.remove_data["utilisateur_langue/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
        this.setState({langue:this.state.langue.filter((data)=>data.id!==id)})
    }
  
    handleDeleteLocalisation=(id)=>{
        this.setState({validate_update:true})
        var data={"utilisateur_id":this.state.idExpert,"pay_id":id}
        try{
          this.state.remove_data["utilisateur_pay/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }catch(err){
          this.state.remove_data["utilisateur_pay/delete"]=[]
          this.state.remove_data["utilisateur_pay/delete"].push(data)
          this.setState({remove_data:this.state.remove_data})
        }
         
          this.setState({localite:this.state.localite.filter((data)=>data.id!==id)})
      }
    handleDeleteSysteme=(id)=>{
      this.setState({validate_update:true})
      var data={"utilisateur_id":this.state.idExpert,"type_systeme_irrigue_id":id}
  
      try{
        this.state.remove_data["utilisateur_type_s_irrigue/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["utilisateur_type_s_irrigue/delete"]=[]
        this.state.remove_data["utilisateur_type_s_irrigue/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
      this.setState({systeme:this.state.systeme.filter((data)=>data.id!==id)})
    }
    handleDeleteSousTypeExpert=(id)=>{
      this.setState({validate_update:true})
      var data={"utilisateur_id":this.state.idExpert,"sous_type_expert_id":id}
  
      try{
        this.state.remove_data["expert_sous_type/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["expert_sous_type/delete"]=[]
        this.state.remove_data["expert_sous_type/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
      this.setState({sous_type_expert:this.state.sous_type_expert.filter((data)=>data.id!==id)})
    }
    handleDeleteThematique=(id)=>{
       this.setState({validate_update:true})
      var data={"utilisateur_id":this.state.idExpert,"thematique_id":id}
  
      try{
        this.state.remove_data["utilisateur_thematique/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }catch(err){
        this.state.remove_data["utilisateur_thematique/delete"]=[]
        this.state.remove_data["utilisateur_thematique/delete"].push(data)
        this.setState({remove_data:this.state.remove_data})
      }
        this.setState({thematique:this.state.thematique.filter((data)=>data.id!==id)})
    }

//delete actions

    handleDeleteActions=()=>{
      
      Object.keys(this.state.remove_data).map((element,idx)=>{
        removeElements(this.state.remove_data[element],element).then(data=>{
        
        })
      })
    }
      
  //check


  handleChangeNew = function (newValue, actionMeta) {
    console.group('Value Changed');
    console.log(newValue);
    console.log("action: " + actionMeta.action);
    console.groupEnd();
  };

  handleCheckLangue=(data)=>{
    var  tab=[]
    this.setState({checkLangue:tab,validate_update:true})
    try{
      data.map((val,idx)=>{
          this.setState({checkLangue:[...this.state.checkLangue,{langue_id:val.value}]})
      })
    }catch(error){} 
  }

  handleCheckLocalisation=(data)=>{
    var  tab=[]
    this.setState({checkLocalisation:tab,validate_update:true})
    try{
      data.map((val,idx)=>{
        this.setState({checkLocalisation:[...this.state.checkLocalisation,{pay_id:val.value}]})
      })
    }catch(error){   
  
    }
  }
  handleChangeSousTypeExpert=(e)=>{

    var data=[]
    this.setState({checkSousTypeExpert:data})
    try{
      e.map((element,idx) =>{
        this.setState({checkSousTypeExpert:[...this.state.checkSousTypeExpert,{"sous_type_expert_id":element.value}]})
      })
    }catch(error){
      this.setState({checkSousTypeExpert:data})
    }

  }


  handleCheckSysteme=(data)=>{
    var  tab=[]
    this.setState({checkSysteme:tab,validate_update:true})
    try{
      data.map((val,idx)=>{
        this.setState({checkSysteme:[...this.state.checkSysteme,{type_systeme_irrigue_id:val.value}]})
      })
    }catch(error){   
    }
  }

  handleCheckThematique=(data)=>{
    var  tab=[]
    this.setState({checkThematique:tab,validate_update:true})
    console.log("tttt",data)
    try{
      data.map((val,idx)=>{
          this.setState({checkThematique:[...this.state.checkThematique,{thematique_id:val.value}]})
      })
    }catch(error){
      this.setState({checkThematique:tab})
    }
  }
  
  handleCheckSousTypeExpert=(data)=>{
    var  tab=[]
    this.setState({checkSousTypeExpert:tab,validate_update:true})
    console.log("tttt",data)
    try{
      data.map((val,idx)=>{
          this.setState({checkSousTypeExpert:[...this.state.checkSousTypeExpert,{sous_type_expert_id:val.value}]})
      })
    }catch(error){
      this.setState({checkSousTypeExpert:tab})
    }
  }


     // upadte 

  



     handleUpdateExpert=()=>{
     
       this.setState({chargement_data:true})

      // supprimer les elements concernés
      this.handleDeleteActions()



      var ressource={
        "nom":$("#nom").val(),
        "prenom":$("#prenom").val(),
        "password": $("#pwd1").val(),
        "status":$("#statut option:selected").val(),
        "telephone":$("#telephone").val(),
        "email":$("#email").val(),
        "adresse":$("#adresse").val(),
        "utilisateur_langues_attributes":_.uniqBy(this.state.checkLangue, 'langue_id'),
        "utilisateur_thematiques_attributes":_.uniqBy(this.state.checkThematique, 'thematique_id'),
        "utilisateur_type_s_irrigues_attributes":_.uniqBy(this.state.checkSysteme, 'type_systeme_irrigue_id'),
        "utilisateur_pays_attributes":_.uniqBy(this.state.checkLocalisation, 'pay_id'),
        "expert_sous_types_attributes":_.uniqBy(this.state.checkSousTypeExpert, 'sous_type_expert_id'),
        
      }

      if($("#show-structure option:selected").val()!=="0"){
        ressource["structure_id"]=$("#show-structure option:selected").val()
      }

      if($("#show-type_expert option:selected").val()!==this.state.expert?.type_expert.libelle){
        ressource["type_expert_id"]=$("#show-type-expert option:selected").val()
        removeSousTypeInExpert(this.state.sous_type_expert,this.state.idExpert).then(data=>{

        })
      }


      //update ressource width image
      // if((($("#pwd1").val()===$("#pwd2").val() ))){
          updateExpert(ressource).then(data=>{
            this.setState({chargement_data:true})
            this.setState({message:"Le profile acteur a été modifié avec succès !"})
            this.setState({show:true,success:true});
            setTimeout(()=>
              window.location.reload(false)
            , 3000)
            //this.getData()
          })
    // }else{
    //   this.setState({message:"Repéter le mot de passe!!",chargement_data:false})
    //   this.setState({show:true,success:false});
    //   $("#pwd2").val("")
    //   $("#pwd1").val("")
    // }
    
  }


    handleModifierExpert=()=>{
    this.setState({accept_update:false,is_compte:true})


    const data=this.state.expert

    if(data.password && data.password!==""){
      this.setState({block_acces:false})
    }


    $("#pwd1").val(data.password)

     
    this.handleChargeStructure()
    this.handleChargeLangue()
    this.handleChargeSysteme()
    this.handleChargeTypeExpert()
    this.handleChargeLocalisation()
    this.handleChargeThematique()
  
   // this.handleChargeTypeExpert()
   $(".owener-close").hide()
   $("#droit").hide()
   $("#droit_d").hide()

    setTimeout(()=>
   { this.setState({accept_update:true})
   
      $(".owener").show()
      $(".show").show()
      this.setState({hide2:"none"})
      this.setState({hide:"block"})

      document.getElementById("nom").readOnly = false;
      document.getElementById("prenom").readOnly = false;
      document.getElementById("telephone").readOnly = false;
      document.getElementById("email").readOnly = false;
      document.getElementById("adresse").readOnly = false;
    }
  , 3000)

    //  if(this.state.accept_update){
      
      
    // }
    }

     handleFindSousTypeActeur=(e)=>{
    var type=[]
    this.state.type_experts.find(val=>val.value==e)?.sous_types.map((el)=>{
      type=[...type,{value:el.id,label:el.libelle}]
      this.setState({sous_type_experts:type})
    })
  }



    
  handleChangeType=(e)=>{
    var data=[]
    var type=[]
    this.setState({validate_update:true,sous_type_experts:data})
    if(e.target.value!=0){
      setTimeout(()=>
           {this.handleFindSousTypeActeur(e.target.value)}
    , 100)
      

    }else{
      this.setState({sous_type_experts:data})
      
    }
  }

  handleAnuler=()=>{
    this.setState({validate_update:false,
      block_acces:false,
      accept_update:true,
      checkSysteme:[],
      checkThematique:[],
      checkUnite:[],
      checkLangue:[],
      checkLocalisation:[],
      checkMot:[],
      checkNewAuteur:[],
      checkSousTypeRessource:[],
      checkNewMot:[],
      checkAcces:[],
      hide:"none",
      remove_data:{}})
    // this.handleChargeAll()
    this.getData()
    $(".owener-close").show()
    $("#droit").show()
    $("#droit_d").show()
    $(".owener").hide()
    $(".show").hide()
    document.getElementById("nom").readOnly = true;
    document.getElementById("prenom").readOnly = true;
    document.getElementById("telephone").readOnly = true;
    document.getElementById("email").readOnly = true;
    document.getElementById("adresse").readOnly = true;
  }
  
    handleChangeAcces = () => {
      console.log("le select",$("#acces option:selected").val())
      if($("#acces option:selected").val()=="Privé"){
          $("#profiles").show()
      }else{
        $("#profiles").hide()
        
        this.setState({profile_id:this.state.public_init_id,validate_update:true})
      }
    }

    handleChangeProfile = (e) => {
    
      try{
        this.setState({profile_id:e.value,validate_update:true})
       
      }catch(e){
        this.setState({profile_id:this.state.public_init_id})
      }
    }

    handleChangeText=()=>{
      this.setState({validate_update:true})
    }

    handleValiderSuppression=()=>{
      document.getElementById("cls").click()
      const id=sessionStorage.getItem("idExpert")
      deleteQueries("utilisateurs/"+id).then(data=>{
        
      this.setState({ok: <Redirect to='/liste-expert'  />});

        // this.setState({message:"Acteur supprimé avec succès!!",title:"Suppression d'acteur"})
        // this.setState({show:true,success:true});
      })
    }
  

    handleValidate=()=>{
      if(this.state.success){
           window.location.reload(false)
      }
      this.setState({show:false})
    }
    onChangeBlocAcces=(e)=>{
    
      this.setState({is_compte:$('.chbx').is(':checked')})
    }

    handleConfirme=()=>{
      document.getElementById("modale").click()
    }



  render() {
    const { pick } = this.state
    const animatedComponents = makeAnimated();
    const isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 5;
    var today = new Date();
    return (
      <React.Fragment>
        {
        (this.state.chargement)?
        (<>
          {this.state.ok}

            <ModalMessage
              show={this.state.show}
              success={this.state.success}
              boutton={this.state.boutton}
              handleValidate={this.handleValidate}
              message={this.state.message}
              titre={this.state.titre}
              onCloseClick={() => this.setState({ show: false })}
            />
            <Confirmer
              bouton="Supprimer"
              titre="Suppression d'acteur"
              message="Voullez-vous vraiment supprimer l'acteur?"
              handleValider={this.handleValiderSuppression}
            />

            <div className="page-content mb-3">
           
                <MetaTags>
                    <title>Fiche de l'acteur de l 'irrigation</title>
                </MetaTags>
                <div className="container-fluid ">
                {/* <Breadcrumbs title="Détails de la ressource" breadcrumbItem="Détails de la ressource" /> */}
                <Row>
                {!this.state.validate_update?
                  <Col md="4">
                    <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Retour
                    </Button>
                  </Col>:null
                }
                  

                  {this.state.profile_user?.droit_expert?.modifier?
                    <Col md="8">
                       {this.state.profile_user?.droit_expert?.supprimer?
                        <div id="droit_d">
                          <Button onClick={this.handleConfirme} className="btn btn-danger" style={{ borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                              Supprimer l'acteur
                          </Button>
                        </div>:null
                        }
                      <div id="droit">
                        <Button onClick={this.handleModifierExpert} style={{ marginRight:"5px",backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                            Modifier l'acteur
                        </Button>
                      </div>
                      {
                        !this.state.accept_update?
                        <Button  style={{width:"150px",backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                          <span   className="spinner-border spinner-border-sm" role="status" aria-hidden="true">...</span>
                      
                      </Button>:null
                      }
                  </Col>:null
                   }
                  
                  
                </Row>
                {this.state.validate_update?
                <Row>
                  <Col md="6">
                  <Button onClick={this.handleRetour} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Retour
                    </Button>
                  </Col>
                  <Col md="6" >
                  
                    
                    {
                    this.state.chargement_data?
                    <Button id="chargement" style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                         
                    </Button>:
                    <Button id="initial" onClick={this.handleUpdateExpert} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                       Appliquer la modification
                    </Button>
                    }

                 
                    
                  </Col>
                </Row>:null
                  }
             

                <hr/>
                
                {/* Couleur noir grisée
                borderColor:"#6A7172" */}
                <Card className="mb-4" style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>
                    <h4 className="text-center mt-2">Description de l'acteur </h4> 
                    <hr/>
                  
               
              
                    <Row className="mt-4"> 
                    <h4 className="mt-2"> <span style={{backgroundColor:"#AAD29A",fontSize:16}} className="badge rounded-pill">{this.state.type_personne}</span></h4>
                        {
                          !this.state.expert.prenom?
                        
                            <Col md="6">
                              <label>Nom </label>
                            
                              <Input
                                className="form-control"
                                type="text"
                                id="nom"
                                readOnly
                                onChange={this.handleChangeText}
                                
                                // placeholder="Titre de la ressource"
                              />
                            </Col>:null
                          }
                      </Row>
                   
                 {
                  this.state.expert.prenom?
                  <Row className="mt-4"> 
                    <Col md="4">
                          <label>Nom </label>
                        
                          <Input
                            className="form-control"
                            type="text"
                            id="nom"
                            readOnly
                            onChange={this.handleChangeText}
                          
                            // placeholder="Titre de la ressource"
                          />
                        </Col>
                      <Col md="8">
                    
                        <label>Prénom</label>
                          
                        <Input
                          className="form-control"
                          type="text"
                          id="prenom"
                          readOnly
                          onChange={this.handleChangeText}
                          // placeholder="Titre de la ressource"
                        />
                      </Col>
                  </Row>:null
                   }

                  {/* <Row className="mt-4">
                    <Col md="12">
                      <label className="owener-close">Fonction </label>
                      <label className="owener">Fonction 
                        <a  
                          onClick={this.handleFonction}
                        >
                          <i className='bx bx-border bxs-pencil bx-xs'></i>
                        </a>
                      </label>
                      <Input
                        className="form-control"
                        type="text"
                        id="fonction"
                        readOnly
                        onBlur={this.handleBlurFonction}
                        // placeholder="Titre de la ressource"
                      />
                    </Col>
                  </Row> */}

                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Email 
                        
                      </label>
                      <Input
                        className="form-control"
                        type="text"
                        id="email"
                        readOnly
                        onChange={this.handleChangeText}
                        // placeholder="Titre de la ressource"
                      />
                    </Col>

                    <Col md="6">
                      <label >Numéro de téléphone </label>
                     
                      <Input
                        className="form-control"
                        type="text"
                        id="telephone"
                        readOnly
                        onChange={this.handleChangeText}
                        // placeholder="Titre de la ressource"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4"> 
                  
                  <Col md="6">
                      <label>Adresse</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="adresse"
                        readOnly
                        onChange={this.handleChangeText}
                      />
                    </Col>
                  
                     
                  </Row>

                  
                  </CardBody>
                </Card>

                

                <Row className="mb-4">
                    
                  <Col md="12">
                    <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                    <CardBody>
                      <h4 className="text-center mt-2">Catégorisation de l'acteur</h4>
                      <hr/>
                      {/* <CardTitle  className="mb-4 h4 ">Catégorisation</CardTitle> */}
                      
                    <Row className="mb-4">
                      <Col md="5">
                        <label>Type d'acteur</label> 
                        <Input
                          className="form-control owener-close"
                          type="text"
                          id="type-expert"
                          readOnly
                          // placeholder="Titre de la ressource"
                        />
                        <select defaultValue={"0"} onChange={this.handleChangeType}  className="form-select show" aria-label="Default select example" id="show-type-expert">
                          {/* <option value="0" selected>{$("#structure").val()}</option> */}
                          {
                            this.state.type_experts.map(
                              (element,idx) =>(
                                  element.label===$("#type-expert").val()?
                                  <option key={element.value} value={element.value} selected>{$("#type-expert").val()}</option>:
                                  <option key={element.value} value={element.value}>{element.label}</option>
                              ))
                          }
                        </select>
                      </Col>
                     
                        <Col md="5" className="show" id="soustypeacteur" >
                        {
                        this.state.sous_type_experts.length?
                           <>
                              <label>Sous type(s) d'acteur(s) associé(s)</label>
                              <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleChangeSousTypeExpert}
                                options={this.state.sous_type_experts}
                                placeholder="Choisir le/les sous type(s) d'acteur(s) associé(s)"
                              />
                              </>:null
                        }
                         </Col>
                       
                      {/* <Col md="5" className="show" id="soustypeacteur" >
                        <label>Sous-type(s) d'acteur(s)</label>
                        <div  >
                          <ReactSelect
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            // onChange={this.handleCheckSousSysteme}
                            // options={this.state.sous_type_ressources}
                            placeholder="Choisir la/les sous-type(s) d'acteur(s)"
                          />
                        </div>
                      </Col> */}
                    </Row>
                      <div className=" mt-4">
                        <label>Sous-type(s) d'acteur(s)</label>
                        {
                          this.state.sous_type_expert.length?
                          <table className="table align-middle">
                            <thead>
                              <tr>
                                <th>Titre</th> <th>Sigle</th> {this.state.sous_type_expert.length?<th style={{display:this.state.hide}}>Action</th>:null}
                              </tr>
                            </thead>
                            <tbody>
                              {
                                (this.state.sous_type_expert.map(
                                  (element,idx)=>(
                                    <tr>
                                      <td style={{ width: "30%" }}>
                                        <p className="mb-0">{element.libelle}</p>
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <p className="mb-0">{element.sigle}</p>
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <a style={{display:this.state.hide}} onClick={this.handleDeleteSousTypeExpert.bind(this,element.id)} ><strong>X</strong></a>
                                      </td>
                                    </tr>
                                  )
                                ))
                              }
                            </tbody>
                          </table>: (<span>Aucun sous type d'acteur associé !</span>)
                        }
                      </div>
                      </CardBody>
                      </Card>
                    </Col>
                    
                  </Row>




                  <Row className="mb-4">
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle  className="mb-4 h4">Langue(s)</CardTitle>
                      
                        <div id="langue" className=" mt-4 show">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckLangue}
                                options={this.state.langues}
                                placeholder="Choisir la/les langue(s)"F
                            />
                        </div>
                        <div className=" mt-4">
                          {
                            this.state.langue.length?
                            <table className="table align-middle">
                                <tbody>
                                
                                {
                                    
                                    (this.state.langue.map(
                                        (element,idx)=>(
                                            <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.nom}</p>
                                            </td>
                                            <td style={{display:this.state.hide,width: "30%"}} className="owener2">
                                                <a style={{display:this.state.hide}} className="owener"  onClick={this.handleDeleteLangue.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )

                                    ))

                                    } 

                                </tbody>
                            </table>:
                            (<span>Aucune langue associé !</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Pays(s)</CardTitle>

                        <div id="localisation" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                   onChange={this.handleCheckLocalisation}
                                   options={this.state.localisations}
                                placeholder="Choisir la/les pays(s)"
                            />
                        </div>
                        <div className=" mt-4">
                        {
                            this.state.localite.length?
                            <table className="table align-middle">
                            <thead>
                                    <tr>

                                        <th>Code(s) du/des pays(s)</th> <th>Pays(s)</th> <th  style={{display:this.state.hide}}>Action</th> 

                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {
                                
                                (this.state.localite.map(
                                    (element,idx)=>(
                                    <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.code}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">{element.nom}</p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                            <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteLocalisation.bind(this,element.id)}><strong>X</strong></a>
                                        </td>
                                    </tr>
                                    )))
                                }
                                </tbody>
                            </table>:
                            (<span>Aucun pays associé !</span>)
                            }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>

                  </Row>



                <Row className="mb-4">
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle  className="mb-4 h4">Type(s) de système(s) irrigué(s)</CardTitle>
                        <div id="typesystemeirrigation" className="show mt-4">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckSysteme}
                                options={this.state.irrigues}
                                placeholder="Choisir la/les type(s) de système(s) irrigué(s)"
                            />
                        </div>
                        <div className=" mt-4">
                        {
                            this.state.systeme.length?
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th>Libelle</th> <th>Sigle</th> {this.state.systeme.length?<th style={{display:this.state.hide}}>Action</th>:null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        (this.state.systeme.map(
                                            (element,idx)=>(
                                             <tr>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.libelle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <p className="mb-0">{element.sigle}</p>
                                                </td>
                                                <td style={{ width: "30%" }}>
                                                    <a style={{display:this.state.hide}} onClick={this.handleDeleteSysteme.bind(this,element.id)} ><strong>X</strong></a>
                                                </td>
                                            </tr>
                                            )

                                        ))

                                    }                              

                                </tbody>
                            </table>:
                            (<span>Aucun systéme d'irrigation associé !</span>)
                                  }
                            </div>
                        </CardBody>
                        </Card>
                    </Col>
                    
                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-2 h4">Thématique(s) </CardTitle>
                        <div id="thematique" className=" mt-4 show">
                            <ReactSelect
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                onChange={this.handleCheckThematique}
                                options={this.state.thematiques}
                                placeholder="Choisir la/les thématique(s)"
                            />
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            {/* <thead>
                                    <tr>
                                        <th>Libelle</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    
                                    {
                                    (this.state.thematique.length!=0)?
                                    (this.state.thematique.map(
                                        (element,idx)=>(
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <p className="mb-0">{element.libelle}</p>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <a style={{display:this.state.hide}} className="owener" onClick={this.handleDeleteThematique.bind(this,element.id)} ><strong>X</strong></a>
                                            </td>
                                        </tr>
                                        )
                                       )
                                    ):(  <tr>
                                        <td style={{ width: "30%" }}>
                                            <p className="mb-0">Aucune thématique associé !</p>
                                        </td>
                                        
                                    </tr>)

                                    } 

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
              {
                this.state.block_acces?
                <Row className="mt-2 mb-4 text-center justify-content-center">
               
                    <Col md="10">
                      <h4><strong>Veuillez cocher cette case si vous voulez attribuer un compte à cet acteur  --{">"} </strong></h4>
                    </Col>
                   <Col md="2">
                      <Input
                        className="form-control chbx pull-left"
                        type="checkbox"
                        id="chbx"
                        onChange={this.onChangeBlocAcces}
                      />
                    </Col>
               </Row> :null
               }
                <Row>
                 {

                    this.state.is_compte?
                     <>
                    
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                          <CardBody>
                          <h4 className="text-center mt-2">Compte de l'acteur</h4>
                            <hr/>
                            <Row className="mt-4"> 
                              <Col md="6">
                                <label>Mot de passe</label>
                                <Input
                                  className="form-control"
                                  onChange={this.handleChangeText}
                                  type="text"
                                  id="pwd1"
                                  placeholder="Mot de passe"
                                />
                              </Col>
                              {/* <Col md="6">
                                <label>Répetez le mot de passe</label>
                                <Input
                                  className="form-control"
                                  onChange={this.handleChangeText}
                                  type="password"
                                  id="pwd2"
                                  placeholder="Répetez le mot de passe"
                                />
                              </Col> */}
                            </Row>
                            <Row className="mt-4"> 
                              <Col md="6">
                                <label>Statut du compte</label>
                                <select className="form-select" 
                                  // onClick={this.handleChangeAcces} 
                                  onChange={this.handleChangeText}
                                  aria-label="Default select example" id="statut"
                                >
                                  {
                                    this.state.status_compte.map((el,idx)=>(
                                      <>
                                      {el.value===this.state.expert?.status?<option selected value={el.value}>{el.label}</option>:
                                        <option value={el.value}>{el.label}</option>
                                      }
                                      </>
                                    ))
                                  }
                                 
                                </select>
                              </Col> 
                            </Row>
                            <hr></hr>

                          </CardBody>
                        </Card> </>:null
                     }
                
                </Row>

                <Row>
                 

                    <Col md="6">
                        <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                        <CardBody>
                        <CardTitle className="mb-4 h4">Type(s) d'accès</CardTitle>
                      
                        <div id="profile" className="mt-4">
                          <Row className="mt-4"> 
                            <Col md="6">
                              <label>Choisissez le type d'accès</label>
                              <select className="form-select" onChange={this.handleChangeAcces} aria-label="Default select example" id="acces">
                                {/* <option selected>Choisir le type d'accès</option> */}
                                <option selected value="Public">Public</option>
                                <option value="Privé">Privé</option>
                              </select>
                            </Col>  
                            <Col md="6" >
                              <div id="profiles">
                              <label>Profil(s)</label>
                              <ReactSelect
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  //isMulti
                                  options={this.state.profile}
                                  placeholder="Choisir le/les profil(s)"
                                  onChange={this.handleChangeProfile} 
                                  aria-label="Default select example" 
                                  id="profile_id"
                                />
                            
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className=" mt-4">
                            <table className="table align-middle">

                            <thead>
                                   
                                </thead>
                                <tbody>
                                
                                     <tr>
                                          <td style={{ width: "30%" }}>
                                                <p className="mb-0">{this.state.acces?.libelle}</p>
                                          </td>
                                           
                                     </tr>
                                    

                                </tbody>
                            </table>
                            </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {this.state.validate_update?
                <Row>
                  <Col md="6">
                    <Button onClick={this.handleAnuler} style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} >
                      Annuler
                    </Button>
                  </Col>
                  <Col md="6" >
                  
                    
                    {
                    this.state.chargement_data?
                    <Button id="chargement" style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                          Envoi...
                    </Button>:
                    <Button id="initial" onClick={this.handleUpdateExpert} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}  >
                       Appliquer la modification
                    </Button>
                    }
                    
                  </Col>
                </Row>:null
                  }


           

                <hr/>
                
                <hr></hr>

             

            </div>
            </div>
             </>
             ):(
          <div style={{marginTop:"250px",textAlign:"center"}}>
            <Spinner type="grow" color="secondary" />
          </div>
        )
        
      }
      </React.Fragment>
    )
  }
}

export default DetailExpert
